import { Injectable } from "@angular/core";
import { AuthService } from "../services/auth.service";
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

    constructor(private auth: AuthService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler) {
        let token = this.auth.get_token();

        if(token.length) {
            const auth_request = request.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + token,
                    'Cache-Control': 'no-cache',
                    'Pragma': 'no-cache',
                    'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
                }
            });
            return next.handle(auth_request);
        }

        const httpRequest = request.clone({
            setHeaders:{
                'Cache-Control': 'no-cache',
                'Pragma': 'no-cache',
                'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
            }
        });

        return next.handle(httpRequest);
    }
}



// WEBPACK FOOTER //
// ./src/app/interceptors/token.interceptor.ts